import { openingSideOpening3 } from "building-common/openings/openingQuery";
import type { WallOpening } from "building-types/openings/wallOpeningTypes";
import { aabb3ByPolyLine3s } from "geom/aabb3";
import type { AABB3 } from "geom/aabb3Types";

export function wallOpeningNew(
  from: Partial<WallOpening> &
    Pick<WallOpening, "handle" | "front" | "back" | "frontPlane" | "backPlane" | "planExtents" | "planExtentsCasing">,
): WallOpening {
  let aabb3: AABB3 | null = null;
  if (from.handle) {
    const front3 = openingSideOpening3(from.front);
    const back3 = openingSideOpening3(from.back);
    aabb3 = aabb3ByPolyLine3s([front3, back3].filter((p) => !!p));
  }

  return {
    hasExteriorCasing: false,
    casingClipsFinish: false,
    hasJamb: false,
    hasWrapping: false,
    hasSill: false,
    mirror: false,
    ...from,
    aabb3,
  };
}
